export const PROTECTED_KEYS = [
  '__skipFilterPatch',
  '__currentPathMirror',
  'canvas',
  'clearRect',
  'filter',
  'getImageData',
  'globalCompositeOperation',
];
